export const environment = {
  production: true,
  backendUrl: 'https://backend.port.mn/',
};
